import script from "./FloatingModuleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingModuleCard.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingModuleCard.vue?vue&type=style&index=0&id=49287e54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49287e54"]])

export default __exports__